import { isAxiosError } from 'axios';

export function getErrorCode(error: unknown): string | undefined {
    if (isAxiosError<{ code: string }>(error)) {
        if (error.response?.data?.code != null) {
            return error.response.data.code;
        }
    }

    return undefined;
}
